<template>
  <div>
    <div class="row">
      <div class="col text-center">
        <router-link to="/profile/business/details/overview">
          <h4 v-bind:class="{ 'black-underline': endPath !== 'overview',
                              'yellow-underline': endPath === 'overview' }">Overview</h4>
        </router-link>
      </div>
      <div class="col text-center">
        <router-link to="/profile/business/details/services">
          <h4 v-bind:class="{ 'black-underline': endPath !== 'services',
                              'yellow-underline': endPath === 'services' }">Services</h4>
        </router-link>
      </div>
      <div class="col text-center">
        <router-link to="/profile/business/details/pictures">
          <h4 v-bind:class="{ 'black-underline': endPath !== 'pictures',
                              'yellow-underline': endPath === 'pictures' }">Photos</h4>
        </router-link>
      </div>
      <div class="col text-center">
        <router-link to="/profile/business/details/about">
          <h4 v-bind:class="{ 'black-underline': endPath !== 'about',
                              'yellow-underline': endPath === 'about' }">About</h4>
        </router-link>
      </div>
      <div class="col text-center">
        <router-link to="/profile/business/details/preferences">
          <h4 v-bind:class="{ 'black-underline': endPath !== 'preferences',
                              'yellow-underline': endPath === 'preferences' }">Preferences</h4>
        </router-link>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data () {
    return {
      endPath: null
    }
  },
  created () {
    this.setEndPath()
  },
  watch: {
    '$route' (to, from) {
      this.setEndPath()
    }
  },
  methods: {
    setEndPath () {
      var pathList = (this.$route.path).split('/')
      this.endPath = pathList[4]
    }
  }
}
</script>

<style scoped>
.black-underline {
  border-bottom: solid;
}

.yellow-underline {
  border-bottom: solid;
  border-color: #feedaa;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/businessProfile/details/Details.vue